import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  HashRouter,
} from "react-router-dom";
import Home from "./Screens/Home/Home";
import { useState, createContext, useEffect } from "react";

export const quickEnquireContext = createContext();
function App() {
  const [quickEnquireData, setQuickEnquireData] = useState(null);

  useEffect(() =>{
    console.log("Made For Lishy from Riley. Good Luck With your business hope it takes you far.")
    },[])

    
  return (
    <div className="app">
      <quickEnquireContext.Provider
        value={{ quickEnquireData, setQuickEnquireData }}
      >
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </Router>
      </quickEnquireContext.Provider>
    </div>
  );
}

export default App;
